import httpClient from "../utils/httpClient";

export const AddToCart = async (params) => {
    const response = await httpClient.post(`/Cart/add-to-cart`, params);
    return response.data;
};

export const CartDelete = async (params) => {
    const response = await httpClient.post(`/Cart/delete-cart`, params);
    return response.data;
};


export const CartDeleteAll = async (params) => {
    const response = await httpClient.post(`/Cart/deleteall-cart`, params);
    return response.data;
};


export const GetCartCount = async (params) => {
    const response = await httpClient.post(`/Cart/get-cart-count`, params || {});
    return response.data;
};

export const UpdateCart = async (params) => {
    const response = await httpClient.post(`/Cart/update-cart`, params);
    return response.data;
};

export const GetMyCart = async (params) => {
    const response = await httpClient.post(`/Cart/cart-list`, params || {});
    return response.data;
};
